/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";
import PropTypes from "prop-types";

class JaFaq extends Component {
  render() {
    const { history } = this.props;

    return (
      <div className="faq-page">
        <div className="faq-container" style={styles.container}>
          <p className="faq-title" style={styles.title}>よくあるご質問と回答（FAQ）</p>

          <p className="faq-subtitle" style={styles.subTitle(64)}>【1】グラブについて</p>

          <p className="faq-question" style={styles.question(10)}>
            グラブビルダーにない機能もカスタマイズできますか？
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            はい、可能です。グラブご注文後、オプション専用ページ{" "}
            <a
              style={{ textDecoration: "underline" }}
              href="https://gloveworks.link"
              target="_blank"
            >
              gloveworks.link
            </a>{" "}
            にて特別なオプションの確認・追加が可能です。ご希望の内容がページ内に見つからない場合は、
            <u
              style={styles.email}
              tabIndex="-1"
              role="button"
              onClick={() =>
                (document.location.href = "mailto:donald@gloveworks.net")
              }
            >
              donald@gloveworks.net
            </u>{" "}
            までお問い合わせいただければ、対応可否を確認いたします。
          </p>

          <p className="faq-question" style={styles.question(24)}>
            グラブの納期はどのくらいですか？
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            ・在庫グラブ・アクセサリー：ご注文後 1〜2営業日以内に発送。配送期間は平均5〜7営業日程度です。
            <br />
            ・カスタムグラブ：決済完了および詳細内容確認後、約5〜16週間かかります。
            <br />
            ※オプションが多い場合や、年末年始などの休業期間を含む場合は遅延する可能性があります。
            <br />
            すべてのグラブはハンドメイドで製作され、厳格な品質検査を経て出荷されます。
          </p>

          <p className="faq-question" style={styles.question(24)}>
            指定したロゴが使用できないと連絡がありました。
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            他社・他者の著作権を侵害する恐れがあるロゴ、政治的メッセージ、ヘイトスピーチ、反社会的な表現を含むものは使用できません。また、使用したロゴに関する法的責任はすべてご注文者様に帰属することをご承知ください。
          </p>

          <p className="faq-subtitle" style={styles.subTitle(64)}>【2】レザーについて</p>

          <p className="faq-question" style={styles.question(10)}>
            ウェブサイトで見た革の色と実物が異なります。
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            モニター環境や撮影時の光加減により、表示される色と実物に差が出る場合があります。また、ビルダーは色の参考用であり、実際の色味とは異なることがあります。革はロットや部位ごとに風合いや色の個体差があり、サイトに即時反映されないこともあるため、あらかじめご了承ください。ご不安な場合は、ご注文前に実物画像のご請求をおすすめいたします。
          </p>

          <p className="faq-question" style={styles.question(24)}>
            白いグラブを注文したのにグレーに見える、革と紐の色が違う。
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            Gloveworksのホワイトレザーは真っ白（スノーホワイト）ではなく、染料染色による自然な風合いのオフホワイトです。革とレースの色味が異なる場合がございますが、これは染色工程上の特性です。
          </p>

          <p className="faq-question" style={styles.question(24)}>
            表面にストレッチマークやキズのようなものがある。
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            当社で使用する革はすべて天然皮革であり、素材の個体差によって自然なシワや筋、風合いが見られます。製品の耐久性や使用上の品質には一切問題ございませんので、ご安心ください。
          </p>

          <p className="faq-question" style={styles.question(24)}>
            裏革（ライニング）とファーの色は？
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            ・ライニングの色は捕球面と同色になります（
            <a
              style={{ textDecoration: "underline" }}
              href="https://gloveworks.link"
              target="_blank"
            >
              gloveworks.link
            </a>{" "}
            にて変更可能）。ご指定がない場合は自動的に捕球面と同色になります。
            <br />
            ・ファーの色：
            <br />
            ゲームデイ：黒 / プロステアハイド・プロキップ：白
            <br />
            ※ファストバックタイプにはファーは付きません。
          </p>

          <p className="faq-question" style={styles.question(24)}>
            Game Day、Pro Steerhide、Pro Kip の違いは？
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            使用しているレザーが異なります：
            <br />
            <br />
            Game Day：米国産ステアハイドを韓国で鞣したもの
            <br />
            <br />
            Pro Steerhide：米国産ステアハイドを日本（寺田またはGTタンナー）で鞣したもの
            <br />
            <br />
            Pro Kip：北米産キップを日本（寺田またはGTタンナー）で鞣したもの
          </p>

          <p className="faq-subtitle" style={styles.subTitle(64)}>【3】カスタマイズについて</p>

          <p className="faq-question" style={styles.question(10)}>
            注文後に確認メールが届きません。
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            ご注文確認・発送通知メールは、ご注文時に入力されたメールアドレス宛に送信されます。迷惑メールフォルダも必ずご確認ください。届いていない場合は、オーダー番号・お名前・注文日・メールアドレスを添えて、
            <u
              style={styles.email}
              tabIndex="-1"
              role="button"
              onClick={() =>
                (document.location.href = "mailto:donald@gloveworks.net")
              }
            >
              donald@gloveworks.net
            </u>{" "}
            までご連絡ください。
            <br />
            また、サイトの「Order Tracking」ページにてメールアドレスと注文番号を入力いただくと、現在のステータスをご確認いただけます。工場の進行状況によりステータス反映が遅れる場合がございます。
          </p>

          <p className="faq-question" style={styles.question(24)}>
            注文エラーで決済ができません。
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            まれに決済エラーが発生しても注文完了メールが届かない場合があります。オーダー番号・お名前・注文日・メールアドレスを添えてメールいただければ、注文を確認し決済用リンクをお送りします。
          </p>

          <p className="faq-question" style={styles.question(24)}>
            注文後の変更・キャンセルは可能ですか？
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            注文後48時間以内であれば変更やキャンセルが可能です。それ以降は製作が開始されるため、変更・返金はできません。注文内容は十分にご確認のうえご注文ください。
          </p>

          <p className="faq-subtitle" style={styles.subTitle(64)}>【4】配送について</p>

          <p className="faq-question" style={styles.question(10)}>
            どの配送業者を利用していますか？
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            DHL、EMS、SF Express、USPS、佐川急便など、配送先や状況に応じて最適な業者が選定されます。工場は中国に、物流倉庫は韓国にございます。
          </p>

          <p className="faq-question" style={styles.question(24)}>
            私書箱（PO Box）への配送はできますか？
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            できません。必ずお受け取り可能な実住所をご記入ください。
          </p>

          <p className="faq-question" style={styles.question(24)}>
            関税は誰が負担しますか？
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            日本・韓国・アメリカ・台湾宛の配送では、現在（2025年7月時点）送料に関税・税金が含まれています。ただし、カナダなど一部地域では関税が送料に含まれない場合があり、その場合はお客様が配送会社からの案内に従い、直接ご負担いただく必要がございます。詳細は、各国の通関規定または配送会社にご確認ください。
          </p>

          <p className="faq-subtitle" style={styles.subTitle(64)}>【5】返品・交換・返金について</p>

          <p className="faq-question" style={styles.question(10)}>
            気に入らなかった場合、返品や交換はできますか？
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            Gloveworksの製品は全て受注生産（オーダーメイド）です。そのため、お客様都合による返品・交換は承っておりません。ただし、当社の不備や製品不良が確認された場合には、交換・返金対応をさせていただきます。
            <u
              style={styles.email}
              tabIndex="-1"
              role="button"
              onClick={() =>
                (document.location.href = "mailto:donald@gloveworks.net")
              }
            >
              donald@gloveworks.net
            </u>{" "}
            までご連絡ください。
          </p>

          <p className="faq-question" style={styles.question(24)}>
            製品保証はありますか？
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            商品お受け取り日から6ヶ月以内に生じた品質上の問題については、保証対象となります。問題が発生した場合は{" "}
            <u
              style={styles.email}
              tabIndex="-1"
              role="button"
              onClick={() =>
                (document.location.href = "mailto:donald@gloveworks.net")
              }
            >
              donald@gloveworks.net
            </u>{" "}
            までご連絡ください。
          </p>

          <p className="faq-subtitle" style={styles.subTitle(64)}>【その他お問い合わせ】</p>

          <p className="faq-question" style={styles.question(10)}>
            英語・日本語・韓国語でのお問い合わせは、以下のメールアドレスまでお願いいたします：
          </p>
          <p className="faq-description" style={styles.descrpiotn(10)}>
            <u
              style={styles.email}
              tabIndex="-1"
              role="button"
              onClick={() =>
                (document.location.href = "mailto:donald@gloveworks.net")
              }
            >
              donald@gloveworks.net
            </u>
          </p>
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    width: '100%',
    maxWidth: 996,
    margin: "auto",
    marginBottom: 64,
    padding: '0 20px',
    boxSizing: 'border-box',
  },
  title: {
    fontFamily: "Roboto Condensed",
    fontSize: 24,
    lineHeight: 1.33,
    letterSpacing: 0.2,
    color: "#142935",
    fontWeight: "bold",
    textAlign: "center",
    marginTop: 50,
  },
  subTitle: (marginTop) => ({
    color: "#000",
    lineHeight: 1.33,
    fontWeight: "bold",
    fontSize: 18,
    marginTop,
  }),
  question: (marginTop) => ({
    marginTop,
    color: "#007dff",
    lineHeight: 1.5,
    fontWeight: "600",
    fontSize: 16,
  }),
  descrpiotn: (marginTop) => ({
    marginTop,
    color: "#142935",
    lineHeight: 1.57,
    fontSize: 14,
  }),
  email: {
    color: "#007dff",
    cursor: "pointer",
    outline: "none",
    fontWeight: "bold",
  },
};

JaFaq.propTypes = {
  history: PropTypes.object,
};

JaFaq.defaultProps = {
  history: {},
};

export default JaFaq;